import type { Permission } from '@/lib/api/role-api'

export type TristateValue = 'none' | 'partial' | 'all'

/** Bật/tắt một mã quyền. Trả tập MỚI để React nhận ra thay đổi. */
export function toggleCode(granted: Set<string>, code: string): Set<string> {
    const next = new Set(granted)
    if (next.has(code)) next.delete(code)
    else next.add(code)
    return next
}

/**
 * Ô tick tổng của một nhóm/khu vực: còn mã chưa cấp thì cấp hết cụm, đã cấp đủ
 * thì gỡ cả cụm. Mã ngoài cụm giữ nguyên.
 */
export function toggleCodes(
    granted: Set<string>,
    codes: string[],
): Set<string> {
    const next = new Set(granted)
    const turnOn = codes.some((c) => !next.has(c))
    for (const code of codes) {
        if (turnOn) next.add(code)
        else next.delete(code)
    }
    return next
}

/** Trạng thái ô tick tổng. Cụm rỗng là "chưa cấp", không phải "cấp hết". */
export function tristate(granted: number, total: number): TristateValue {
    if (granted === 0 || total === 0) return 'none'
    return granted === total ? 'all' : 'partial'
}

/** Số quyền khác so với lúc mở màn — đếm cả vừa cấp lẫn vừa gỡ. */
export function changedCount(
    baseline: Set<string>,
    working: Set<string>,
): number {
    let n = 0
    for (const code of baseline) if (!working.has(code)) n++
    for (const code of working) if (!baseline.has(code)) n++
    return n
}

/** Tìm quyền theo tên tiếng Việt hoặc theo mã kỹ thuật. */
export function matchesPermissionSearch(
    permission: Pick<Permission, 'code' | 'name'>,
    term: string,
): boolean {
    const needle = term.trim().toLowerCase()
    if (!needle) return true
    return (
        permission.code.toLowerCase().includes(needle) ||
        permission.name.toLowerCase().includes(needle)
    )
}
